import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import Success from "../assets/images/successful.png";

const Successfully = () => {
    return (
        <div className="LoginArea" >
            <div className="LoginBox">
              <div className="SuccessPassword">
              <figure>
                    <img src={Success} />
                </figure>
                <p className="Successfull">Congratulations! <br/> Your password has been updated successfully!!</p>
                <Link className="Button" to="/">Login to Continue</Link>
              </div>
            </div>
        </div>
    );
}
export default Successfully